import React, { FC, memo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useMedia } from "react-use";

import { MEDIA_SIZE_MD } from "@/core/media";
import { IAssignment } from "@/data/assignments";
import { Flex } from "@/eworkitComponents";
import { usePreviousRoutePath } from "@/infrastructure/Route";
import { router } from "@/views/router";

import { AssignmentsList } from "./AssignmentsList";
import { AssignmentsTable } from "./AssignmentsTable";

export interface IAssignmentsProps {
  assignments: IAssignment[];
}

export const Assignments: FC<IAssignmentsProps> = memo(({ assignments }) => {
  const history = useHistory();
  const { currentLocationState } = usePreviousRoutePath();
  const isMediumScreen = useMedia(MEDIA_SIZE_MD);

  const handleOnClick = useCallback(
    (rowData: IAssignment) =>
      history.push(router.get("assignments.detail", { assignmentId: rowData.id }).path, currentLocationState),
    [history],
  );

  return (
    <Flex width={12}>
      {isMediumScreen ? (
        <AssignmentsList assignments={assignments} onRowClick={handleOnClick} />
      ) : (
        <AssignmentsTable assignments={assignments} onRowClick={handleOnClick} />
      )}
    </Flex>
  );
});
